import { render, staticRenderFns } from "./ArticleSliderBlock.vue?vue&type=template&id=2862c708&scoped=true"
import script from "./ArticleSliderBlock.vue?vue&type=script&lang=js"
export * from "./ArticleSliderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862c708",
  null
  
)

export default component.exports